import React from "react";
import "./Footer.modules.css";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleFooterClick = (e, id) => {
    e.preventDefault();

    if (location.pathname !== "/") {
      navigate("/");

      setTimeout(() => {
        const element = document.getElementById(id);
        if (element)
          element.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    } else {
      const element = document.getElementById(id);
      if (element)
        element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="footer py-5 text-white-50">
      <div className="container">
        <div className="row g-4">
          <div className="col-xl-3 col-md-6 col-12">
            <div className="img mb-3">
              <img
                src="/logo my store.jfif"
                alt="My Store"
                style={{ maxHeight: "50px", objectFit: "contain" }}
              />
            </div>
            <p className="my-3 text-white-50 fs-6">
              بيئتك المعرفية المتكاملة للمناهج والتعلم الذكي
            </p>
            <div className="social-links d-flex gap-3 fs-5 mt-3">
              <a href="#facebook" className="text-white-50">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#twitter" className="text-white-50">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a href="#instagram" className="text-white-50">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#tiktok" className="text-white-50">
                <i className="bi bi-tiktok"></i>
              </a>
              <a href="#linkedin" className="text-white-50">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 col-12">
            <h5 className="text-uppercase text-white mb-3">Quick Links</h5>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <a
                  href="/"
                  onClick={(e) => handleFooterClick(e, "home")}
                  className="text-white-50 text-decoration-none"
                >
                  Home
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="#services"
                  onClick={(e) => handleFooterClick(e, "services")}
                  className="text-white-50 text-decoration-none"
                >
                  Services
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="#about"
                  onClick={(e) => handleFooterClick(e, "about")}
                  className="text-white-50 text-decoration-none"
                >
                  About Us
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="#contact"
                  onClick={(e) => handleFooterClick(e, "contact")}
                  className="text-white-50 text-decoration-none"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div className="col-xl-3 col-md-6 col-12">
            <h5 className="text-uppercase text-white mb-3">Our Services</h5>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <Link
                  to="/request-service"
                  className="text-white-50 text-decoration-none"
                >
                  Request Service
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/privacy"
                  className="text-white-50 text-decoration-none"
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/terms"
                  className="text-white-50 text-decoration-none"
                >
                  Terms Of Service
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-xl-3 col-md-6 col-12 text-white">
            <h5 className="text-uppercase mb-3">Contact info</h5>

            <div className="d-flex align-items-start gap-2 mb-3">
              <i className="bi bi-geo-alt text-warning fs-5"></i>
              <div>
                <h6 className="mb-0 text-white">Location :</h6>
                <span className="text-white-50 fs-6">Egypt</span>
              </div>
            </div>

            <div className="d-flex align-items-start gap-2">
              <i className="bi bi-telephone-fill text-warning fs-5"></i>
              <div>
                <h6 className="mb-0 text-white">Call us :</h6>
                <span className="text-white-50 fs-6" dir="ltr">
                  +2123456789
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
